import Header from './../../../Headers/HeaderForAreLoggedIn/index.vue'
import ProgressHUD from './../../../ProgressHUD/index.vue'
import LayoutMain from './../../../../layouts/LayoutMain.vue';
import VueCropper from 'vue-cropper'
import { Api, Toast, Helper } from './../../../../services'

export default {
  name: 'FundProjectAdd',
  props: [],
  components: {
    LayoutMain,
    Header,
    ProgressHUD,
    VueCropper,
  },
  data() {
    return {
      project: {
        name: '',
        theme: '',
        type: '',
        description: '',
        coverImage: '',
        supportImages: [],
        videoURL: '',
        country: '',
        numberPeople: '',
        whatProblem: '',
        documentations: [],
        howAddressingProblem: '',
        benefit: '',
        behind: '',
        amountEarned: 0,
        goal: null,
        organisation: "",
        continent: '',
        contact: '',
        position: '',
        logo: '',
        descriptionOrganisation: '',
        fb: '',
        tw: '',
        website: '',
        draft: false,
      },
      user: {
        address: "",
        city: "",
        country: "",
        location: "",
        state: "",
        zipcode: "",
      },
      validationMessage: '',
      types: {
        0: 'Solar',
        1: 'Wind',
        2: 'Bio mass',
        3: 'Hydro',
        4: 'Other renewables',
      },
      option: {
        img: null,
        size: 1,
        outputType: 'png',
        res: '',
        w: 1200,
        h: 400,
      },
      countries: "",
      draft: false,
      editMode: true,
      addressSearch: '',
      sign: "",
      sign2: "",
      validDocFiles: true,
      validImageFile: true,
      validImagesFiles: true,
      validLogoFile: true,
      isEdit: false,
    }
  },
  computed: {
    isAddress() {
      // check if walletAddressETH is empty
      if (this.user.location.latitude === '' && this.user.location.longitude === '') return true // userAddress is required
      return false
    },
    years () {
      const year = new Date().getFullYear()
      return Array.from({length: year - 1979}, (value, index) => 1980 + index)
    }
  },
  methods: {
    setHeightImage() {
      var pic_box = $('.picture-box')
      if (pic_box && pic_box[0]) {
        var h = document.getElementById('content').clientHeight
        pic_box[0].style.height =
          (h > screen.availHeight ? h - 80 : screen.availHeight - 80) + 'px'
      }
    },

    // whenever the document is resized, re-set the 'fullHeight' variable
    handleResize(event) {
      this.setHeightImage()
    },

    saveDraftProject() {
      this.draft = true;
      this.saveProject();
    },

    onCountryChange() {
      console.log("**************** this.project.country ***********")
      console.log(this.project.country[1])
      let self = this;
      axios.get("https://restcountries.eu/rest/v2/alpha/" + this.project.country[1])
           .then(function (response) {
              console.log("response>>>>>>>>>>>>>>>>>>>>>>>>>")
              console.log(response)
              if (response.status !== 200) {
                self.project.continent = '';
              } else {
                self.project.continent = response.data.region;
              }
           })
           .catch(function (error) {
             console.log(`Bad Request: ${error}`);
           });

    },

    async saveProject() {
      try {
        console.log("draft>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>")
        console.log(this.draft)
        if (!this.draft){
          if (this.project.documentations.length == 0) this.validDocFiles = false;
          if (this.project.coverImage.length == 0) this.validImageFile = false;
          if (this.project.supportImages.length == 0) this.validImagesFiles = false;
          if (this.project.logo.length == 0) this.validLogoFile = false;
          const isValid = await this.$validator.validateAll('firstForm')

          if (!isValid || !this.validDocFiles || !this.validImageFile || !this.validImagesFiles || !this.validLogoFile) {
              Toast.validationFieldsError({ toast: this.$toast })
              return
          }
        } else {
          if (this.project.name == "") {
            Toast.validationFieldsError({ toast: this.$toast })
          }
        }
        this.$refs.progress.show()

        this.project.country = this.project.country[0]

        var formData = new FormData(), userFormData = new FormData()
        for (var key in this.project) {
          formData.append(key, this.project[key])
        }

        if (this.project.documentations)
          for (var i = 0; i < this.project.documentations.length; i++) {
            formData.append(
              'documentationfiles' + i,
              this.project.documentations[i]
            )
          }

        if (this.project.supportImages)
          for (var index = 0; index < this.project.supportImages.length; index++) {
            formData.append('supportImages' + index, this.project.supportImages[index])
          }

        formData.append('coverImage', this.project.coverImage[0])
        formData.append('logo', this.project.logo[0])

        formData.append('draft', this.draft)

        console.log("********************* PRJ ****************")
        console.log(this.project)

        var response
        if (this.isEdit) {
          formData.append('id', this.project.id)
          response = await Api.editFundProject(formData)
        } else {
          response = await Api.addFundProject(formData)
        }

        this.$router.push(
          '/greenfund/' + response.data.project._id
        )
      } catch (error) {

        console.log("error>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>")
        console.log(error)
        this.validationMessage = 'Something went wrong.'

        Toast.error({
          toast: this.$toast,
          title: 'Error',
          message: 'Something went wrong.',
        })
      } finally {
        this.$refs.progress.hide()
      }
    },

    onFileDocumentationsChange(event) {
      var files = event.target.files || event.dataTransfer.files
      this.validDocFiles = this.onFileChange(files)
      this.project.documentations = files
    },
    onFileCoverImageChange(event){
      var files = event.target.files || event.dataTransfer.files
      console.log("cover Files***********************")
      console.log(files)
      this.validImageFile = this.onFileChange(files)
      this.project.coverImage = files
    },
    onFileImagesChange(event) {
      var files = event.target.files || event.dataTransfer.files
      this.validImagesFiles = this.onFileChange(files)
      this.project.supportImages = files
    },
    onFileLogoChange(event) {
      var files = event.target.files || event.dataTransfer.files
      this.project.logo = files
      this.validLogoFile = this.onFileChange(files)
    },
    onFileChange(files) {
      // var files = event.target.files || event.dataTransfer.files
      if (files.length > 4 || files.length < 1) {
        this.$toast.error({
          title: 'Error',
          message: 'You can upload up from one from to four images',
          color: '#BD362F',
        })
        return false;
      }

      for (var i=0; i<files.length; i++) {
        console.log("files --------------------->" + i)
        console.log(files[i].type)
        if (files[i].size > 10485760) {
          this.$toast.error({
            title: 'Error',
            message: 'You can upload up files size not more 10MB',
            color: '#BD362F',
          })
          return false;
        } else if (files[i].type != "image/jpeg" && files[i].type != "image/png") {
          this.$toast.error({
            title: 'Error',
            message: 'You can upload up files types "png", "jpeg"',
            color: '#BD362F',
          })
          return false;
        }
      }
      return true;

      // if (files && files[0]) {
      //   var reader = new FileReader()
      //   let _self = this
      //   reader.onload = e => {
      //     var img = new Image()
      //     img.onload = function() {
      //       _self.option.w = img.width / (img.height / 400)
      //       console.log('The width of the image is ' + img.width + 'px.')
      //     }
      //     img.src = reader.result
      //     _self.option.img = e.target.result
      //   }
      //   reader.readAsDataURL(files[0])
      // }

      /*

      var files = event.target.files || event.dataTransfer.files
      if (files && files[0]) {
        this.newAvatarImmage = files[0]

        // Auto refresh Avatar on page
        var self = this
        var reader = new FileReader()
        reader.onload = e => (self.userData.image = e.target.result)
        reader.readAsDataURL(files[0])
      }

      */
    },
    async getCurrentUser() {
      try {
        var response = await Api.myProfileSmallInfo()
        this.user = response.data.user
        this.affilietCode = response.data.affilietCode
        this.project.affilietCode = response.data.affilietCode
        console.log("data user >>>>>>>>>>>>")
        console.log(this.user)

        this.user.country = this.user.country
        console.log(this.user.country)

      } catch (error) {
        this.validationMessage = 'Something went wrong.'

        Toast.error({
          toast: this.$toast,
          title: 'Error',
          message: 'Something went wrong.',
        })
      }
    },
    async getProject() {
      try {
        if (this.$route.name == "GreenFundEdit") {
          this.isEdit = true

          var response = await Api.getFundById(this.$route.params.id);
          var resultDate = response.data.results

          this.project.id = resultDate._id
          this.project.name = resultDate.name
          this.project.email = resultDate.email
          this.project.theme = resultDate.theme
          this.project.type = resultDate.type
          this.project.description = resultDate.description
          this.project.coverImage = resultDate.coverImage
          this.project.supportImages = resultDate.supportImages
          this.project.videoURL = resultDate.videoURL
          this.project.country = this.countries.filter(x => x.name == resultDate.country).map(x => [x.name, x.code])[0]
          this.project.numberPeople = resultDate.numberPeople
          this.project.whatProblem = resultDate.whatProblem
          this.project.howAddressingProblem = resultDate.howAddressingProblem
          this.project.benefit = resultDate.benefit
          this.project.behind = resultDate.behind
          this.project.amountEarned = resultDate.amountEarned
          this.project.goal = resultDate.goal
          this.project.organisation = resultDate.organisation
          this.project.continent = resultDate.continent
          this.project.contact = resultDate.contact
          this.project.position = resultDate.position
          this.project.logo = resultDate.logo
          this.project.descriptionOrganisation = resultDate.descriptionOrganisation
          this.project.fb = resultDate.fb
          this.project.tw = resultDate.tw
          this.project.website = resultDate.website
          this.project.draft = resultDate.draft
        }
      } catch (error) {
        this.validationMessage = 'Something went wrong.'

        Toast.error({
          toast: this.$toast,
          title: 'Error',
          message: 'Something went wrong.',
        })
      }
    } ,
    updateSearch() {
    //   var address
    //   console.log(document.getElementById('google-map-user-info_map_edit'))
    //   if(this.project.streetAddress != "" && this.project.streetAddress != undefined) {
    //     console.log("address 1 ************************************")
    //     console.log(this.address)
    //     this.address = this.address + this.project.streetAddress
    //     this.sign = ","
    //   }
    //   if(this.project.city != "" && this.project.city != undefined) {
    //     console.log("address 2 ************************************")
    //     console.log(this.address)
    //     this.address = this.address + this.sign + this.project.city
    //     this.sign2 = ","
    //   }
    //   console.log("address************************************")
    //   console.log(this.address)
    //   document.getElementById('google-map-user-info_map_edit').value = this.address
    // },
    // updateSearchCountry() {
    //   if(this.project.country != "" && this.project.country != undefined) {
    //     console.log("address 3 ************************************")
    //     console.log(this.address)
    //     this.address = this.address + this.sign + this.project.country
    //     document.getElementById('google-map-user-info_map_edit').focus()
    //   }
    //   document.getElementById('google-map-user-info_map_edit').value = this.address
    }
  },
  async created() {
    this.countries = require('./../../../../data/country.js')

    await this.getCurrentUser()
    await this.getProject()

    // $('[data-toggle="tooltip"]').tooltip();
    $('.add-project').tooltip({
        selector: "[data-toggle=tooltip]",
        container: "body"
    })

    await new Promise(resolve => this.$nextTick(resolve))

    this.$refs.progress.hide()
  },
  mounted() {
    this.setHeightImage()
    this.user.country = "United Kingdom"
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
}



// WEBPACK FOOTER //
// ./src/components/Project/GreenFund/FundProjectAdd/FundProjectAdd.component.js